import { Directive, Input, OnDestroy } from '@angular/core';
import { Question } from '@player/+survey/question/question-base';
import { Questions } from '@shared/enums/questions.enum';

@Directive()
export abstract class QuestionInput<T = string> extends Question<T> implements OnDestroy {
  @Input()
  defaultAnswer: T = '' as unknown as T;

  ngOnDestroy(): void {
    if (this.questionData && this.questionData.type !== Questions.INPUT_CHECKBOX && this.isActive && this.isFocused) {
      const value = (this.inputField && this.inputField.nativeElement.value) as unknown as T;

      if (value !== this.answer) {
        this.updateValidity(value);
      }
    }
  }
}
